import React, { useState } from "react";
import { Button, Container, Center } from "@chakra-ui/react";


import { FeedbackList } from "../Feedback/components/listFeedback";

export default function Feedback() {

    return (
        <Container maxW="xxl" mt={100}>
            <FeedbackList />
        </Container>
    );
}
